import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './App';
import {applyTheme} from './theme';
import './styles.css';

applyTheme();

const root = document.getElementById('root');
if (!root) throw new Error('PursuitDeck root element is missing.');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
